import Router from 'next/router';
import { AppUser, Permissions, SessionUser } from './authTypes';
import { getRoleBasedRedirectUrl, getRoleBasedRedirectUrlLegacy } from './getRoleBasedRedirect';
import { EngagementEvents, logError, logKariusEvent } from '../Analytics';

export const getUserIsRestricted = (user: SessionUser | AppUser): boolean => {
  if (isUserLoggedInAsLogicalApiToken(user) && user.kariusPermissions) {
    return (
      user.institution.allowRestrictedAccess && user.kariusPermissions.includes(Permissions.RestrictedReadOnInstitution)
    );
  }
  if (user.effectivePermissions) {
    return (
      user.institution.allowRestrictedAccess &&
      user.effectivePermissions.includes(Permissions.RestrictedReadOnInstitution)
    );
  }
  return false;
};

export const getUserCanGainAccess = (user: SessionUser | AppUser): boolean => {
  return getUserIsRestricted(user) && user.institution.allowGainAccess;
};

export const isUserLoggedInAsLogicalApiToken = (user?: AppUser): boolean => {
  if (!user) {
    return false;
  }

  if (user.kariusPermissions && user.kariusPermissions.length > 0) {
    return true;
  }
  return false;
};

export const redirectByUserRole = async (userSession?: AppUser, options?: { refreshPage?: boolean }) => {
  if (!userSession) {
    await Router.push('/');
    return;
  }
  const redirectUrl: string = isUserLoggedInAsLogicalApiToken(userSession)
    ? getRoleBasedRedirectUrl(userSession)
    : getRoleBasedRedirectUrlLegacy(userSession.role);
  logKariusEvent(EngagementEvents.login, { redirectURL: redirectUrl });
  if (options?.refreshPage) {
    // Return a Promise that never resolves, since the page will unload after the redirect.
    return new Promise<never>(() => {
      window.location.replace(redirectUrl);
    });
  } else {
    await Router.replace(redirectUrl).catch((e) => {
      logError(`Error redirecting to user role URL: ${redirectUrl}`, e);
    });
  }
};
